<template>
  <timeoutUnsent></timeoutUnsent>
</template>

<script>
import timeoutUnsent from "@/view/analysis/timeoutUnsent/index.vue";
export default {
  name: "delayShipments",
  components: {
    timeoutUnsent,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
